import React from "react";
import { Box, Card, CardContent, Stack, useMediaQuery, useTheme } from "@mui/material";
import DataGridTable from "./DataGridTabel";

/**
 * Reusable responsive wrapper:
 * - Desktop/tablet: renders a DataGrid.
 * - Mobile: renders a list of cards via `renderCard`.
 */
export default function ResponsiveDataGridCards({
  rows = [],
  columns = [],
  pageSize = 5,
  rowHeight,
  renderCard,
  empty = null,
  cardGap = 1.5,
  cardSx,
  gridBoxSx,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!rows || rows.length === 0) return empty;

  if (!isMobile) {
    return (
      <Box sx={gridBoxSx}>
        <DataGridTable
          initialColumns={columns}
          initialRows={rows}
          initialPageSize={pageSize}
          initialRowHeight={rowHeight}
        />
      </Box>
    );
  }

  return (
    <Stack spacing={cardGap}>
      {rows.map((row, idx) => (
        <Card key={row?._id || row?.id || idx} sx={cardSx}>
          <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
            {renderCard ? renderCard(row, idx) : null}
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
}

